const nl = {
  nav: {
    home: "Home",
    about: "Over ons",
    destinations: "Bestemmingen",
    tours: "Tours & Pakketten",
    gallery: "Galerij",
    testimonials: "Reviews",
    blog: "Blog",
    contact: "Contact",
    experiences: "Ervaringen",
    vip: "VIP Business",
    vipFull: "VIP Zakenreizen",
    worldcup: "Wereldbeker 2030",
    careers: "Carrières",
    chatWhatsApp: "Chat op WhatsApp",
    jewishHeritage: "Kosher Reizen",
    menu: "Menu"
  },
  common: {
    selectLanguage: "Taal selecteren",
    languages: {
      nl: "Nederlands"
    }
  },
  aria: {
    selectLanguage: "Taal selecteren",
    openMenu: "Menu openen",
    closeMenu: "Menu sluiten",
    closeDetails: "Details sluiten",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    kingAlt: "Koning van Marokko",
    logoAlt: "MoroccoLovesYou logo",
    kosherOptionsAlt: "Kosher opties"
  }
};

export default nl;
